<ng-container *ngIf="results | async as resultats">
    <ng-container *ngIf="resultats.length !== 0">
        <div class="row-details search-item">
            <div class="icon-type">
                <aa-icon-circle class="blue duotone" [faIcon]="'fas ' + category.icon">
                </aa-icon-circle>
            </div>
            <div>{{ category.application | translate }} / {{ category.module | translate }}</div>
        </div>
        <aa-search-result-item *ngFor="let result of resultats" [searchResult]="result">
        </aa-search-result-item>
    </ng-container>
</ng-container>
